class Retain24Controller extends AbstractIntegrationController
	@register()
	@inject 'configuration'

	integrationId: 'retain24'

	initialize: ->
		@actions =
			disconnect: true
			save: false

	save: ->
		super(@configuration, true).then (response) =>
			@configuration = response.data

	afterDisconnect: ->
		@configuration =
			is_active: false

	isSaveButtonEnabled: ->
		return @mainForm.$valid &&
			!@saving &&
			!(!@configuration.certificate_file && @configuration.is_active && @mainForm.$pristine) &&
			!(!@configuration.certificate_file && !@configuration.is_active)
